import React from 'react';

import { useThemeMode } from '../../fenrir-provider/theme-mode/theme-mode-provider';

type LogoPropsTypes = {
  width?: number;
  variant?: 'light' | 'dark';
};

const PALETTE = {
  inverse: {
    text: '#ffffffb3',
    triangle: 'var(--aw-palette-arcticAurora-azure)',
    wolf: 'transparent',
  },
  normal: {
    text: '#00000099',
    triangle: 'var(--aw-palette-arcticAurora-sea)',
    wolf: 'transparent',
  },
};

export const Logo: React.FC<LogoPropsTypes> = ({
  width,
  variant: _variant,
  ...rest
}) => {
  const { mode } = useThemeMode();

  const title = 'Arctic Wolf';

  const variant = _variant ?? mode;
  const palette = variant === 'dark' ? PALETTE.inverse : PALETTE.normal;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 261.5 92.9"
      style={{ display: 'block', width: width || 100 }}
      {...rest}
    >
      <title>{title}</title>
      <path fill={palette.wolf} d="M111.7 92.4L56 .3.2 92.4" />
      <g fill={palette.triangle}>
        <path d="M64.5 36.9l1.1 7-2 8.1 4.6-2.5-1.1-8.9-2.6-3.7zM44.1 74.4l-4.2 2.3-7.2.6 7.3 1c0-.1 4.1-3.9 4.1-3.9zm2.8-15.8l4.6-4-.3-3.3-4.3 7.3zm24.5 2.8l.2-5.6-1 2.2.8 3.4z" />
        <path d="M44.1 74.4l-4.2 2.3-7.2.6 7.3 1c0-.1 4.1-3.9 4.1-3.9zm2.8-15.8l4.6-4-.3-3.3-4.3 7.3zm17.6-21.7l1.1 7-2 8.1 4.6-2.5-1.1-8.9-2.6-3.7z" />
        <path d="M24.8 87.9l4-3.7 3.9-7.1-6.2-1.3 9.9-8.5 1.9-3.8 3.2-4.3 3.3-6.1 3.2-3.5 5.3-2.2 7.2-14.3 4.6 2.8 2.9 3.6 1.7 9 3.4-4 2.1 1 .4 2.4-1.4 8-2.5 6.5 2.1 10.7-1.8-.4 1.7 5.5-1.3-.1 2.1 6.9-2.2-.8 2.8 6.3.5 1.9h36.1L55.9.1.1 92.4h21.8l4.4-4.6-1.5.1z" />
        <path d="M71.4 61.4l.2-5.6-1 2.2.8 3.4z" />
      </g>
      <path
        fill={palette.text}
        d="M222.7 55.4h23v5.8h-16.5v10.1H243V77h-13.9v15.6h-6.3c-.1-12.4-.1-24.7-.1-37.2zm-21.9 0h6.3v31.3h13v5.8h-19.2c-.1-12.3-.1-24.7-.1-37.1zm-5.3 13.5c0-8.3-5.1-13.7-13.2-14.2h-1.4c-8.4.4-13.6 5.8-13.6 14.2 0 4-.2 8 .3 12 .8 7.8 6.7 11.6 13.2 11.7h1.4c6.4-.1 12.2-3.9 13-11.6.5-4.1.3-8.1.3-12.1zm-6.6 10.4c-.1 2.8-1.4 5.3-4.1 6.5-.9.4-1.8.6-2.8.7h-1.2c-.9-.1-1.8-.3-2.8-.7-2.8-1.2-4-3.6-4.1-6.5-.2-3.8-.2-7.7 0-11.5.2-4.1 3-6.8 6.9-7h1.2c3.9.2 6.7 2.9 6.9 7 .1 3.8.1 7.7 0 11.5zM158 55.4c-1 3.8-4.5 17.7-6.2 24.3 0 .2-.1.4-.2.9l-.7-2.1c-2.1-6.9-4.7-15.9-6.8-23.1h-5.4c-2.1 7.1-4.7 16.1-6.8 23.1-.2.6-.4 1.1-.7 2.1-.2-.6-.2-.7-.2-.9-1.6-6.6-5.2-20.5-6.2-24.3h-7.4c3.5 12.3 6.9 25.3 10.3 37.2h6.2c2.4-8.2 4.9-15.9 7.4-24.5 2.6 8.6 5 16.2 7.4 24.5h6.2c3.4-12 6.8-25 10.3-37.2H158zM255.6 34c2 .8 4 1.7 5.9 2.5-1.5 4.9-5.8 8.3-11.3 8.6-2.6.1-5.3-.2-7.8-1.1-4.6-1.7-7.1-5.5-7.5-10.2-.4-5-.4-10.1 0-15.1.6-7 6.7-11.8 14.1-11.4 6.2.3 10.7 3.4 12.4 8.7-2 .8-3.9 1.6-6 2.4-1.4-3.5-4-5.1-7.6-4.9-3.5.2-6.1 2.4-6.4 5.9-.4 4.5-.3 9 0 13.5.2 3.5 2.8 5.7 5.8 6.1 3.8.5 6.4-1 7.9-4.5l.5-.5zm-66.8-18l-6 2.4c-1.5-3.6-4.2-5.2-7.9-4.8-3.6.4-6 2.6-6.3 6.4-.3 4.2-.3 8.4 0 12.6.3 3.7 2.7 6.1 5.9 6.4 3.9.5 6.4-1 8-4.6 0-.1.1-.1.3-.3 1.9.8 3.9 1.6 5.9 2.5-1.4 4.8-5.8 8.3-11.3 8.6-2.6.1-5.3-.2-7.8-1.1-4.6-1.6-7.1-5.4-7.5-10-.4-5.1-.4-10.3 0-15.4.6-7 6.8-11.6 14-11.3 5.5.3 9.7 2.5 12.1 7.7.3.2.4.5.6.9zm29.1-2.7h-10.3v31.4h-6.5V13.3h-10.3V7.5h27c.1 2 .1 3.8.1 5.8zm5.2-5.7h6.3v37.2h-6.3V7.6zm-127 33c-.5 1.4-1 2.7-1.5 4.2h6.8c.9-2.5 2.9-8.2 2.9-8.2s.9 0 5 .1c2.5 0 5 0 7.5-.1 1.2 0 1.5.1 1.5.1s1.9 5.6 2.9 8.2h6.8c-.3-1-.6-1.7-.8-2.4L114 7.6h-5.3c-4 10.2-8.8 22.9-12.6 33zm20.1-9.6h-10c1.6-5 3.2-9.9 4.8-14.9h.4c1.5 5 3.1 9.9 4.8 14.9zm20.9 13.8s0-.1 0 0h-6.4 6.4zM151.4 28c4.6-2.2 7-6.6 6.2-11.4-.8-4.8-4.2-8.4-9.3-8.8-4.9-.4-9.8-.2-14.8-.3h-3v37.2h6.4V29.5h7c1.7 4.2 4.8 11.4 6.4 15.2h7.2c-2.3-5.2-5-11.1-7.3-16.2.6-.2.9-.3 1.2-.5zm-5.3-4.4c-2.9.1-5.9 0-9 0V13.5c3.5 0 7-.2 10.4.1 2.6.3 3.9 2.5 3.7 5.1-.3 2.8-2.2 4.8-5.1 4.9z"
      />
    </svg>
  );
};
